import { useState } from "react";
import "./ResetPassword.css";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { publicRequest } from "../../RequestMethods";

export const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error("Les mots de passe ne correspondent pas.", { autoClose: 2000 });
      return;
    }

    setIsLoading(true);
    try {
      await publicRequest.post("password-reset/reset", { token, newPassword });
      toast.success("Mot de passe réinitialisé avec succès !", { autoClose: 1500 });
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Ce lien est invalide ou a expiré.", {
        autoClose: 2500,
      });
    } finally {
      setIsLoading(false);
    }
  };

  if (!token) {
    return (
      <div>
        <h1 className="login-title">Réinitialiser le mot de passe</h1>
        <div className="signup-container">
          <p className="reset-password-error">
            Lien invalide : aucun jeton de réinitialisation trouvé dans l'URL.
          </p>
          <p>
            <Link to="/forgot-password">Demander un nouveau lien</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h1 className="login-title">Réinitialiser le mot de passe</h1>

      <div className="signup-container">
        <form className="signup-form" onSubmit={handleSubmit}>
          <input
            type="password"
            name="newPassword"
            placeholder="Nouveau mot de passe"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            minLength={6}
          />
          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirmer le mot de passe"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            minLength={6}
          />
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Réinitialisation..." : "Réinitialiser le mot de passe"}
          </button>
        </form>

        <p>
          <Link to="/login">Retour à la connexion</Link>
        </p>
      </div>

      <ToastContainer position="top-right" />
    </div>
  );
};

export default ResetPassword;
